export const VideoConsultationIcon = ({
  customClassName = '',
  onMouseEnter,
  onMouseLeave
}: {
  customClassName?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClassName}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d="M33.4993 7.66461C33.3436 7.60482 33.1938 7.5748 33.05 7.5748C32.7265 7.5748 32.4572 7.68884 32.2414 7.91629L24.9999 15.1399V12.1751C24.9999 10.7494 24.4938 9.53068 23.4815 8.51835C22.4692 7.50614 21.2506 7 19.8248 7H7.17491C5.74952 7 4.53056 7.50614 3.51816 8.51835C2.50614 9.53068 2 10.7494 2 12.1751V24.8251C2 26.2507 2.50614 27.4693 3.51822 28.4816C4.53062 29.4939 5.74958 30 7.17498 30H19.8249C21.2507 30 22.4693 29.4939 23.4816 28.4816C24.4939 27.4693 25.0001 26.2507 25.0001 24.8251V21.8421L32.2416 29.0836C32.4574 29.311 32.7266 29.425 33.0501 29.425C33.194 29.425 33.3437 29.3951 33.4994 29.3354C33.9668 29.1317 34.2003 28.7784 34.2003 28.2753V8.72503C34.2001 8.22166 33.9667 7.86834 33.4993 7.66461Z"
        fill="currentColor"
      />
    </svg>
  )
}
